import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { tap } from 'rxjs/operators';
import { TableService } from '@morningstar/shared/base/base-service';
import { FilterComponent } from '@morningstar/shared/ui-kit/filter';
import { BaseComponent } from './base-component';

export abstract class TableComponent<T> extends BaseComponent {

  filterableEntries: T[] = [];

  abstract columnsToDisplay: string[];
  dataSource = new MatTableDataSource<T>();

  filter: FilterComponent;
  paginator: MatPaginator;
  sort: MatSort;

  constructor(service: TableService<T>) {
    super(service);

    service.tableData$.subscribe(this.handleTableData);      
  }

  initializeTable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.filter) {
      this.filter.filtered$.pipe(
        tap(data => {
          this.dataSource.data = data;
        })
      ).subscribe();
    }
  }

  applyFilter() {
    //  Manually triggers the datasource's filter which doesn't use the string
    this.dataSource.filter = Math.random().toString();
  }

  handleTableData = (data: T[]) => {
    this.dataSource.data = data;

    if (data) {
      this.filterableEntries = data.slice();
    }

    if (this.filter) {
      this.filter.filterableArray = this.filterableEntries;
      this.filter.filterEntries();
    }
  }
}
